import PaymentPlanBuilder from '../project-widgets/PaymentPlanBuilder';

const INP = {
  width: '100%', padding: '10px 13px', borderRadius: 5,
  background: 'rgba(255,255,255,.05)', border: '1px solid rgba(201,168,76,.18)',
  color: '#fff', fontSize: '.84rem', fontFamily: 'var(--sans)',
  outline: 'none', boxSizing: 'border-box',
};
const LBL = {
  fontSize: '.6rem', color: 'rgba(255,255,255,.36)',
  letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: 5, display: 'block',
};

export default function Step3Financials({ form, update }) {
  const sectionHead = {
    color: 'rgba(255,255,255,.85)', fontSize: '.82rem', fontWeight: 700,
    marginBottom: '1rem', marginTop: '.5rem',
    paddingBottom: '.5rem', borderBottom: '1px solid rgba(201,168,76,.1)',
    display: 'flex', alignItems: 'center', gap: 7,
  };

  const subHead = {
    color: 'var(--gold)', fontSize: '.78rem', fontWeight: 600,
    marginBottom: '.75rem', marginTop: '1.2rem',
  };

  return (
    <div>
      <div style={sectionHead}>
        <span style={{ color: 'var(--gold)' }}>③</span> Financials & Delivery
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '.85rem 1rem', marginBottom: '1rem' }}>
        {/* Starting Price */}
        <div>
          <label style={LBL}>Starting Price (EGP)</label>
          <div style={{ position: 'relative' }}>
            <input
              id="step3-starting-price"
              name="startingPrice"
              style={{ ...INP, paddingRight: 50 }}
              type="number"
              min={0}
              value={form.startingPrice}
              onChange={e => update({ startingPrice: e.target.value })}
              placeholder="5000000"
            />
            <span style={{
              position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
              color: 'rgba(201,168,76,.5)', fontSize: '.7rem', fontWeight: 600,
              pointerEvents: 'none',
            }}>EGP</span>
          </div>
          {form.startingPrice && (
            <div style={{ fontSize: '.68rem', color: 'rgba(255,255,255,.28)', marginTop: 3 }}>
              {Number(form.startingPrice).toLocaleString('en-EG')} EGP
            </div>
          )}
        </div>

        {/* Delivery Date */}
        <div>
          <label style={LBL}>Delivery Date</label>
          <input
            id="step3-delivery-date"
            name="deliveryDate"
            style={INP}
            value={form.deliveryDate}
            onChange={e => update({ deliveryDate: e.target.value })}
            placeholder="Q4 2027"
          />
          <div style={{ fontSize: '.66rem', color: 'rgba(255,255,255,.22)', marginTop: 3 }}>
            Format: Q4 2027, 2028, or a specific date
          </div>
        </div>
      </div>

      {/* Payment Plans */}
      <div style={subHead}>Payment Plans</div>
      <PaymentPlanBuilder
        plans={form.paymentPlans}
        onChange={plans => update({ paymentPlans: plans })}
      />
    </div>
  );
}
